export default "__VITE_ASSET__CSfUMELJ__"